import React, { useEffect, useState } from "react";
import axios from "axios";
import { fmtRelative } from "../../utils/format";

const VERB_MAP = {
  success: { verb: "SIGN-IN", cls: "v-ok" },
  login: { verb: "SIGN-IN", cls: "v-ok" },
  ACCREDITATION_APPROVED: { verb: "APPROVED", cls: "v-ok" },
  CAMPAIGN_APPROVED: { verb: "APPROVED", cls: "v-ok" },
  CAMPAIGN_REJECTED: { verb: "REJECTED", cls: "v-fail" },
  ACCREDITATION_REJECTED: { verb: "REJECTED", cls: "v-fail" },
  failure: { verb: "FAILED", cls: "v-fail" },
  ACCREDITATION_IN_REVIEW: { verb: "REVIEW", cls: "v-warn" },
  CAMPAIGN_IN_REVIEW: { verb: "REVIEW", cls: "v-warn" },
  logout: { verb: "SIGN-OUT", cls: "v-mute" },
};

const verbFor = (status) => VERB_MAP[status] || { verb: status || "EVENT", cls: "v-info" };

const initialsFor = (email) => {
  if (!email) return "··";
  const local = email.split("@")[0];
  return (local.slice(0, 2) || "··").toUpperCase();
};

const ActivityPanel = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    axios
      .get(process.env.REACT_APP_API + "admin/activities?limit=10&page=1", {
        headers: { "x-access-token": token },
      })
      .then((res) => {
        setActivities(res.data?.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <section className="card">
      <header className="card__head">
        <h2 className="card__title">Recent activity</h2>
        <span className="card__sub">last events</span>
      </header>
      <div className="card__body card__body--flush">
        {loading && (
          <div style={{ padding: 14, color: "var(--tx-3)", fontSize: "var(--t-sm)" }}>
            Loading…
          </div>
        )}
        {!loading && activities.length === 0 && (
          <div style={{ padding: 14, color: "var(--tx-3)", fontSize: "var(--t-sm)" }}>
            No recent activity
          </div>
        )}
        {!loading &&
          activities.map((a) => {
            const v = verbFor(a.loginStatus);
            return (
              <div key={a.id} className="act-row">
                <span className="act-ava">{initialsFor(a.userEmail)}</span>
                <div>
                  <div className="act-line">
                    <b>{a.userEmail || "Unknown"}</b>{" "}
                    <span className="muted">{a.loginStatus || "login"}</span>
                  </div>
                  <div className="act-meta">
                    <span>{fmtRelative(a.timestamp)}</span>
                    {a.ipAddress && (
                      <>
                        <span className="sep">·</span>
                        <span>{a.ipAddress}</span>
                      </>
                    )}
                  </div>
                </div>
                <span className={"act-verb " + v.cls}>{v.verb}</span>
              </div>
            );
          })}
      </div>
    </section>
  );
};

export default ActivityPanel;
